import React from "react";
import { Leaf, Moon, Users, Zap } from "lucide-react";
import { HERO } from "@/content";
import WhatsAppButton from "@/components/WhatsAppButton";
import ProductShot from "@/components/ProductShot";
import Counter from "@/components/Counter";
import Reveal from "@/components/Reveal";

const ICONS = { Moon, Users, Leaf, Zap };

export default function Hero() {
  return (
    <section
      className="relative overflow-hidden"
      style={{ background: "var(--crema)" }}
      data-testid="section-hero"
    >
      {/* blobs orgánicos */}
      <div
        className="blob"
        style={{
          width: 360,
          height: 360,
          top: -160,
          left: -190,
          background: "var(--rosa-soft)",
          opacity: 0.75,
        }}
      />
      <div
        className="blob"
        style={{
          width: 340,
          height: 340,
          top: 160,
          right: -170,
          background: "var(--lima-soft)",
          opacity: 0.7,
        }}
      />

      <div className="container-page relative z-[1] pt-9 pb-2 md:pt-14">
        <div className="flex flex-col md:flex-row md:items-center md:gap-8">
          {/* Columna texto 52% */}
          <div className="md:w-[52%]">
            <Reveal>
              <span className="chip">
                <Leaf size={15} strokeWidth={2} aria-hidden="true" />
                {HERO.badge}
              </span>
            </Reveal>

            <Reveal delay={80}>
              <h1 className="h1-display mt-5" style={{ color: "var(--vino)" }}>
                No estás gorda.
                <br />
                Estás <span style={{ color: "var(--lima)" }}>inflamada</span>.
                <br />
                Y eso se arregla en 5 noches.
              </h1>
            </Reveal>

            <Reveal delay={160}>
              <p
                className="mt-5 max-w-[36ch] md:max-w-[44ch]"
                style={{ color: "var(--carbon)", fontSize: 17 }}
              >
                {HERO.sub}
              </p>
            </Reveal>

            <Reveal delay={240} className="mt-7">
              <WhatsAppButton section="hero" size="lg" full className="md:w-auto" />
              <p className="mt-3 text-[13px]" style={{ color: "var(--gris)" }}>
                {HERO.micro}
              </p>
            </Reveal>
          </div>

          {/* Columna imagen 48% */}
          <Reveal delay={200} className="md:w-[48%] mt-10 md:mt-0">
            <ProductShot />
          </Reveal>
        </div>
      </div>

      {/* Franja de estadísticas */}
      <div className="container-page relative z-[1] pb-12 pt-4 md:pt-8">
        <div
          className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 p-4 md:p-6"
          style={{
            background: "var(--blanco)",
            borderRadius: 24,
            boxShadow: "var(--shadow-soft)",
          }}
          data-testid="hero-stats"
        >
          {HERO.stats.map((s, i) => {
            const Icon = ICONS[s.icon] || Leaf;
            return (
              <Reveal
                key={s.label}
                delay={i * 80}
                className="flex flex-col items-center text-center px-1 py-2"
              >
                <span
                  className="flex items-center justify-center rounded-full mb-2"
                  style={{ width: 40, height: 40, background: "var(--lima-soft)" }}
                >
                  <Icon size={20} strokeWidth={2} style={{ color: "var(--vino)" }} />
                </span>
                <span
                  className="font-display"
                  style={{ fontSize: 30, color: "var(--vino)", lineHeight: 1 }}
                >
                  <Counter value={s.value} prefix={s.prefix} suffix={s.suffix} />
                </span>
                <span
                  className="mt-1 text-[13px] leading-snug"
                  style={{ color: "var(--gris)" }}
                >
                  {s.label}
                </span>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
